import paths from '../../shared/route/paths'
import CustomerAddPage from './CustomerAdd.Page'

export const CustomerAddModule = {
  isPrivate: false,
  routers: {
    path: paths.CUSTOMER.CUSTORMER_ADD,
    component: CustomerAddPage,
  },
}
